import { createObjToSave } from "../scripts/saveLoad";
import md5 from "crypto-js/md5";
import { compressJson, decompressJson } from "./gzip";
import { uint8ArrayToBase64 } from "./uint8ArrayToBase64";
import { base64ToUint8Array } from "./base64ToUint8Array";

const POST_URL = "https://esd-mebel.ru/api/save-config";
const GET_URL = "https://esd-mebel.ru/api/load-config";
const GET_PRICE = "https://esd-mebel.ru/api/get-price";
const GET_PDF_DATA = "https://esd-mebel.ru/api/get-pdf-data";

export const saveConfigOnServ = async (obj) => {
    const compressed = await compressJson(obj);
    const base64 = uint8ArrayToBase64(compressed);

    const response = await fetch(POST_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data: base64 }),
    });

    return await response.json();
};

export const getConfigOnServ = async (filename) => {
    const response = await fetch(`${GET_URL}/?filename=${filename}.json`);
    const data = await response.json();

    if (data.success) {
        const uint8arr = base64ToUint8Array(data.data); // base64 → Uint8Array
        const obj = await decompressJson(uint8arr); // распаковка gzip
        return obj;
    }
    return null;
};

export const getPrice = async () => {
    const response = await fetch(GET_PRICE);

    const data = await response.json();
    if (data.success) return data.data;
    return null;
};

export const getPdfData = async (filename) => {
    const response = await fetch(`${GET_PDF_DATA}/?filename=${filename}`);

    const data = await response.json();
    if (data.success) return data.data;
    return null;
};

export const getSpecLink = async (isCartToPDF = false, saveObjToJson = null) => {
    const servObj = parent.servObj || window.servObj;

    const json = isCartToPDF && saveObjToJson ? saveObjToJson : await createObjToSave();

    const jsonStr = JSON.stringify(json);
    const currentHash = md5(jsonStr).toString();

    // проверяем кэш
    if (servObj.cache.lastSavedHash === currentHash && servObj.cache.lastGeneratedLink) {
        return servObj.cache.lastGeneratedLink;
    }

    // сохраняем на сервер
    function removeJsonSuffix(str) {
        return str.replace(/\.json$/, "");
    }
    const link_data = await saveConfigOnServ(json);
    const URL = window.origin;
    const currentPath = window.location.pathname.split("/").slice(0, -1).join("/");
    const link = `${URL}${currentPath}/?filename=${removeJsonSuffix(link_data.filename)}`;

    // обновляем кэш
    servObj.cache.lastSavedHash = currentHash;
    servObj.cache.lastGeneratedLink = link;

    return link;
};
